import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const deliverables = [{
    title: 'El Manual Original "Cero Panza 14" (PDF)',
    desc: 'La hoja de ruta paso a paso para desinflamarte en dos semanas.'
  }, {
    title: 'La Lista de Compras Alpha',
    desc: 'Qué comprar en Walmart, Costco o Publix para no fallar.'
  }, {
    title: 'Protocolo Anti-Hambre',
    desc: 'Técnicas de saciedad para que nunca sientas que estás "a dieta".'
  }, {
    title: 'Guía de Supervivencia en el BBQ',
    desc: 'Cómo ser el alma de la fiesta y comer carne sin arruinar tus resultados.'
  }, {
    title: 'Plan de Acción Día a Día',
    desc: 'Exactamente qué hacer desde que te despertás hasta que te acostás.'
  }];
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-129">
      <div className="max-w-5xl mx-auto" data-id="element-130">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-12 text-center uppercase" data-id="element-131">
          Lo que te llevás <span className="text-brand-orange" data-id="element-132">HOY</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-133">
          {deliverables.map((item, index) => <div key={index} className={`bg-dark-bg p-6 rounded-lg border border-gray-800 flex items-start ${index === deliverables.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto w-full' : ''}`} data-id="element-134">
              <CheckCircle2 className="w-8 h-8 text-brand-orange mr-4 flex-shrink-0 mt-1" data-id="element-135" />
              <div data-id="element-136">
                <h3 className="font-oswald text-xl font-bold mb-2 uppercase text-white" data-id="element-137">
                  {item.title}
                </h3>
                <p className="font-inter text-gray-400" data-id="element-138">{item.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}